import {Loader} from '@mantine/core';
import {WhiteBgButtonThin} from '@packages/ui';
import {useInfiniteGetCommunityTopicList} from '../../../../../core/repositories/communityRepository';
import {useAuth} from '../../../../../core/usecases/auth/AuthContext';
import {CommunityTopicComponent} from './CommunityTopicComponent';

export const RelatedContentList: React.FC<{
  recruitmentItemId: number;
}> = ({recruitmentItemId}) => {
  const {user} = useAuth();
  const {data, isLoading, isFetching, hasNextPage, fetchNextPage} =
    useInfiniteGetCommunityTopicList({
      recruitmentIDs: [recruitmentItemId],
      limit: 5,
      config: {
        enabled: !!user && !user.isDemoUser,
      },
    });

  if (!user || user.isDemoUser) {
    return null;
  }

  return isLoading ? (
    <div className="w-full h-[150px] flex justify-center items-center">
      <Loader color="gray" />
    </div>
  ) : (
    data && data?.pages.length > 0 && (
      <div className="mt-16">
        <h2 className="bg-primary-1 p-12 text-white text-md leading font-bold">
          関連しているページ
        </h2>
        <div className="bg-white p-16">
          <h3 className="bg-background-1 p-8 text-md text-black leading font-bold">
            コミュニティ
          </h3>
          <div className="mt-16">
            {data.pages.map(
              (page) =>
                page.ok &&
                page.value.topics.map((topic) => (
                  <CommunityTopicComponent key={topic.id} topic={topic} />
                )),
            )}
            {isFetching && (
              <div className="w-full h-[150px] flex justify-center items-center">
                <Loader color="gray" />
              </div>
            )}
          </div>
          {!isFetching && hasNextPage && (
            <WhiteBgButtonThin
              label="もっと見る"
              type="button"
              isPrimary={false}
              isDisabled={isFetching || !hasNextPage}
              className="w-full mt-32"
              onClick={async () => {
                await fetchNextPage();
              }}
            />
          )}
        </div>
      </div>
    )
  );
};
